import { TextDivider } from "@/components/Dividers"
import { formatBusinessRegistrationNumber } from "@/utils/formats"

export type SelectedCustomerBarProps = {
  organizationName: string
  representativeName: string
  businessRegistrationNumber: string
}

export function SelectedCustomerBar({
  organizationName,
  representativeName,
  businessRegistrationNumber,
}: SelectedCustomerBarProps) {
  return (
    <div className="rounded bg-gray-02 px-4 py-3 text-sm text-gray-10">
      {organizationName}
      <TextDivider variant="horizontal" className="mx-2 text-divider">
        |
      </TextDivider>
      {representativeName}
      <TextDivider variant="horizontal" className="mx-2 text-divider">
        |
      </TextDivider>
      {formatBusinessRegistrationNumber(businessRegistrationNumber)}
    </div>
  )
}
